import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import UnitStatusHistory from './UnitStatusHistory';
function UnitStatusSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>{({ agencies }) => <UnitStatusHistory filter={agencies} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default UnitStatusSearch;
